<template>
    <div class="online">
    
      <div class="content">
        <div class="coder" style="background:#eee">
          <editor v-model="code" lang="java" theme="chrome" class="editor editor-font-2" ref="aceEditor" id="codeEditor" style="border-top:1px solid #ddd"
          :options="editorOptions" @paste="handlePaste"
          ></editor>

          <div class="font-setting">
            <div :class="font == 1?'item active':'item'" @click="changeFont(1)">小</div>
            <div :class="font == 2?'item active':'item'" @click="changeFont(2)">中</div>
            <div :class="font == 3?'item active':'item'" @click="changeFont(3)">大</div>
          </div>

          <div style="position: absolute;right:250px;top:10px">
            <select v-model="language" @change="changeLanguage">
                <option value="processing">Processing</option>
                <option value="java">Java</option>
            </select>

             
          </div>


          <div style="position: absolute;right:360px;top:8px;" v-if="language == 'java'">
            <input v-model="stdin" placeholder="stdin输入内容"/>
          </div>

          <div v-if="resultText!=null" style="z-index:1;position: absolute;left:41px;width:calc(100% - 41px);bottom:0px;background:#ccc;height:150px;padding:10px 15px;overflow: auto">
            <div v-html="resultText"></div>

            <div style="position: absolute;top:15px;right:15px;font-size:20px;cursor: pointer;" @click="resultText = null">X</div>
          </div>


          <button @click="saveToFile" class="btn btn-sm btn-info" style="position:absolute;right:160px;top:8px">保存代码</button>

          <div v-if="connected" style="right:130px;top:15px;position: absolute;background:green;width:12px;height:12px;border-radius:6px">&nbsp;</div>
          <div v-if="!connected" style="right:130px;top:15px;position: absolute;background:red;width:12px;height:12px;border-radius:6px">&nbsp;</div>
        </div>
        <div class="panel">
          <div class="result">
            <div class="title">画布</div>
            <canvas ref="canvas" id="myCanvas" style="max-width:100% !important;max-height:100% !important"></canvas>
          </div>
          <div class="notes">
            <div class="tabs">
              <div :class="tab =='basic'?'tab active':'tab'" @click="switchTab('basic')">Java编程基础</div>
              <div :class="tab =='algo'?'tab active':'tab'" @click="switchTab('algo')">数据结构与算法</div>
              <div :class="tab =='promote'?'tab active':'tab'" @click="switchTab('promote')">专项提高</div>
              <div :class="tab =='exam'?'tab active':'tab'"  @click="switchTab('exam')">课后练习</div>
              <!-- <div :class="tab =='advanced'?'tab active':'tab'" @click="switchTab('advanced')">进阶课</div>
              <div :class="tab =='advancedexam'?'tab active':'tab'" @click="switchTab('advancedexam')">进阶练习</div> -->
            </div>
  
            <div v-if="tab == 'project'">
              <div v-for="(p,index) in projects" @click="loadProject(p)" class="project-row">
                  <div>{{index+1}}. {{ p.name }}</div>
                  <div>
                    <img src="/images/code.png" style="width:20px"/>
                  </div>
                </div>
            </div>
            <div v-if="tab == 'exam'">
              <div v-for="(c,index) in exam" >
                  <div @click.stop="openClass(c)"  class="class-row">{{ c.name }}
                  
                     <img src="/images/open.png" style="width:20px;float:right" v-if="!c.open"/>
                     <img src="/images/close.png" style="width:20px;float:right" v-if="c.open"/>
                  </div>
                 
  
                  <div v-if="c.open" style="margin-top:3px">
                    <div v-for="(s,index1) in c.topic" class="topic-row" @click="loadProject(s)">
                      <div>{{index1+1}}. {{ s.name }}</div>
                      <div>
                        <img src="/images/code.png" style="width:20px"/>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
  
            <div v-if="tab == 'basic'">
              <div v-for="(c,index) in classes" >
                  <div @click.stop="openClass(c)"  class="class-row">{{ c.name }}
                  
                     <img src="/images/open.png" style="width:20px;float:right" v-if="!c.open"/>
                     <img src="/images/close.png" style="width:20px;float:right" v-if="c.open"/>
                  </div>
                 
  
                  <div v-if="c.open" style="margin-top:3px">
                    <div v-for="(s,index1) in c.topic" class="topic-row" @click="loadProject(s)">
                      <div>{{index1+1}}. {{ s.name }}</div>
                      <div>
                        <img src="/images/code.png" style="width:20px"/>
                      </div>
                    </div>
                  </div>
                </div>
            </div>


            <div v-if="tab == 'algo'">
              <div v-for="(c,index) in algo" >
                  <div @click.stop="openClass(c)"  class="class-row">{{ c.name }}
                  
                     <img src="/images/open.png" style="width:20px;float:right" v-if="!c.open"/>
                     <img src="/images/close.png" style="width:20px;float:right" v-if="c.open"/>
                  </div>
                 
  
                  <div v-if="c.open" style="margin-top:3px">
                    <div v-for="(s,index1) in c.topic" class="topic-row" @click="loadProjectDirect(s)">
                      <div>{{index1+1}}. {{ s.name }}</div>
                      <div>
                        <img src="/images/code.png" style="width:20px"/>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <div v-if="tab == 'promote'">
              <div v-for="(c,index) in promote" >
                  <div @click.stop="openClass(c)"  class="class-row">{{ c.name }}
                  
                     <img src="/images/open.png" style="width:20px;float:right" v-if="!c.open"/>
                     <img src="/images/close.png" style="width:20px;float:right" v-if="c.open"/>
                  </div>
                 
  
                  <div v-if="c.open" style="margin-top:3px">
                    <div v-for="(s,index1) in c.topic" class="topic-row" @click="loadProjectDirect(s)">
                      <div>{{index1+1}}. {{ s.name }}</div>
                      <div>
                        <img src="/images/code.png" style="width:20px"/>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <div v-if="tab == 'advancedexam'">
              <div v-for="(c,index) in advancedexam" >
                  <div @click.stop="openClass(c)"  class="class-row">{{ c.name }}
                  
                     <img src="/images/open.png" style="width:20px;float:right" v-if="!c.open"/>
                     <img src="/images/close.png" style="width:20px;float:right" v-if="c.open"/>
                  </div>
                 
  
                  <div v-if="c.open" style="margin-top:3px">
                    <div v-for="(s,index1) in c.topic" class="topic-row" @click="loadProjectDirect(s)">
                      <div>{{index1+1}}. {{ s.name }}</div>
                      <div>
                        <img src="/images/code.png" style="width:20px"/>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

          </div>
        </div>
      </div>
 
      <div class="buttons" v-if="editorOptions.showGutter">
        <img src="/images/right.png" style="width:30px;margin-right:10px;" v-if="result == 1"/>
        <img src="/images/error.png" style="width:30px;margin-right:10px;" v-if="result == 0" data-toggle="tooltip" data-placement="top" title="Tooltip on top"/>
        <button @click="run" class="btn btn-info" style="margin-right:10px" :disabled="running">{{ running? '运行中...':'运行'}}</button>
        <button @click="stop" class="btn btn-info">停止</button>
      </div>
  
      <div class="error-layer" v-if="error != null">
        {{ error }}
      </div>
     
    </div>
  </template>
  
  <script>
  import editor from 'vue2-ace-editor'
  import bus from '../utils/bus';
  import util from '../utils/util';
  require('brace/mode/java');
  require('brace/theme/chrome');
  
  
  
  export default {
    data() {
      return {
        code: "void setup(){\n\tsize(800,600);\n}",
        processing: null,
        projects:[],
        classes:[],
        advanced:[],
        promote:[],
        exam:[],
        algo:[],
        advancedexam:[],
        tab:"basic",
        font:2,
        connected:false,
        language:'processing',
        stdin:"",
        running:false,
        editorOptions: {
          enableBasicAutocompletion: false,
          enableLiveAutocompletion: false,
          enableSnippets: false,
          enableLinking: false,
          foldStyle: 'manual',
          showGutter:true,
        },
        socket:null,
        loopCheck:true,
        result:-1,
        error:null,
        lastLength:0,
        resultText:null,
      };
    },
    components:{
      editor
    },
    mounted() {
      // if(this.$store.state.user == null){
      //     $('#loginDialog').modal('show');
      // }
      // else{

      var name = util.getSearchString("name");
      
        this.loadList();
        this.connectLoop();
        
     // }


      setTimeout( ()=>{
        document.getElementsByClassName("ace_text-input")[0].addEventListener('paste', this.handlePaste);
      },500);
    },
    methods: {
      saveToFile(){
        const content = this.code; // 替换成你要保存的文本内容
        const blob = new Blob([content], { type: 'text/plain' });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'code.txt'; // 替换成你想要的文件名

        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      },
      connectLoop(){
        var mobile = util.getSearchString("name");
        var target = util.getSearchString("target");

        if(mobile != null && mobile != ""){
          if(!this.connected){
            this.connectServer();
          }

          var interval = setInterval( ()=>{
            if(!this.connected){
              this.connectServer();
            }
            else{
              clearInterval(interval);
            }
          },5000);
          
        }
      },
      handlePaste(){
        if(this.socket != null){
          var mobile = util.getSearchString("mobile");
          var target = util.getSearchString("target");

          if(mobile == null || mobile == ""){
              return;
          }
          var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
            try{
              this.socket.send(sendStr);
            }
            catch( err){
    
            }
        }
      },
      changeFont(f){
        this.font = f;
        if(f == 1){
          $("#codeEditor").removeClass("editor-font-1");
          $("#codeEditor").removeClass("editor-font-2");
          $("#codeEditor").removeClass("editor-font-3");
          $("#codeEditor").addClass("editor-font-1");
        }
        else if(f == 2){
        
          $("#codeEditor").removeClass("editor-font-1");
          $("#codeEditor").removeClass("editor-font-2");
          $("#codeEditor").removeClass("editor-font-3");
          $("#codeEditor").addClass("editor-font-2");
        
        }
        else if(f == 3){
          $("#codeEditor").removeClass("editor-font-1");
          $("#codeEditor").removeClass("editor-font-2");
          $("#codeEditor").removeClass("editor-font-3");
          $("#codeEditor").addClass("editor-font-3");
        }
      },
      connectServer(){
        
        var mobile = util.getSearchString("mobile");
        var target = util.getSearchString("target");
     
        if(mobile == null || mobile == ""){
            mobile = util.getSearchString("name");
        }
        
        if(target == null || target == ""){
            target = "patrick";
        }
 
        const socket = new WebSocket('wss://wss.dctechonline.cn:8024');

        this.socket = socket;
  
        // When the connection is established
        socket.addEventListener('open', event1 => {
          console.log('WebSocket connection established.');
          
          socket.send(JSON.stringify(
            {
                type:"user",
                mobile:mobile,
                target:target
            }));


            var interval2 = setInterval( ()=>{
              if(this.loopCheck == false){
                
                clearInterval(interval2);
                this.connected = false;
                this.connectLoop();
                return;
              }
              else{
                socket.send(JSON.stringify(
                {
                    type:"loopcheck",
                    mobile:mobile
                }))
                this.loopCheck = false;
                console.log('check successful');
              }
            },20000);


            this.connected = true;

            socket.addEventListener('message', event => {
          // 创建一个 FileReader 对象 
            const reader = new FileReader();
    
            // 当 FileReader 加载完成后，将 Blob 转换为字符串
            reader.addEventListener('loadend', () => {
              const text = reader.result;
              const data = JSON.parse(text);
              const { type, value,from } = data;
              console.log(data);
              if (type === 'classcode' && from == target) {
                // Update the editor with the new text
                this.code = value;
              }
              else if(type ==="loopcheck"){
                this.loopCheck = true;
              }
            });
    
            // 读取 Blob 内容
            reader.readAsText(event.data);
          });
    
          // // When the editor's content changes
          this.$refs.aceEditor.$vnode.elm.children[0].addEventListener('input', event => {
          // var target = target;
            var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
            try{
              socket.send(sendStr);
            }
            catch( err){
    
            }
          
          });
        });
  
        // When a message is received from the server
        
      },
      openClass(c){
        if(c.open){
          c.open = false;
        }
        else{
          c.open = true;
        }
      },
      switchTab(tab){
        this.tab = tab;
      },
      loadList(){
        var r = new Date().getTime();
        var name = util.getSearchString("name")
        this.$http.get("/data/custom/"+name+"-exam.json?random="+r).then(response => {
          this.exam = response.data;
        });
  
        this.$http.get("/data/custom/" + name +".json?random="+r).then(response => {
          this.classes = response.data;
        });

        this.$http.get("/data/custom/" + name +"-algorithm.json?random="+r).then(response => {
          this.algo = response.data;
        });

        this.$http.get("/data/custom/" + name +"-promote.json?random="+r).then(response => {
          this.promote = response.data;
        });

        // this.$http.get("/data/advancedexam.json?random="+r).then(response => {
        //   this.advancedexam = response.data;
        // });
      },
      changeLanguage(e){
          this.code = "";
          this.resultText = null;
      },
      loadProject(p){
         this.resultText = null;
          if(p.language){
            this.language = p.language;
          }
          else{
            this.language = 'processing';
          }
          var r = new Date().getTime();
          this.$http.get(p.path+"?random="+r, { responseType: 'arraybuffer' }).then(response => {
            const decoder = new TextDecoder('gb2312'); // 指定字符编码为utf-8
            const content = decoder.decode(response.data); // 将二进制数据转换为字符串
            this.code = content;
          }).catch(error => {
           
          });
      },
      loadProjectDirect(p){
        this.resultText = null;
          if(p.language){
            this.language = p.language;
          }
          else{
            this.language = 'processing';
          }
          var r = new Date().getTime();
          this.$http.get(p.path+"?random="+r, { responseType: 'arraybuffer' }).then(response => {
            const decoder = new TextDecoder('utf-8'); // 指定字符编码为utf-8
            const content = decoder.decode(response.data); // 将二进制数据转换为字符串
            this.code = content;
          }).catch(error => {
           
          });
      },
      run() {
        if(this.running){
            return;
        }

        this.running = true;
        if(this.language == 'processing'){
          this.result = -1;
          this.error = null;
          if(this.processing != null){
            this.processing.exit();
            this.processing = null;
          }
    
          var elements1 = document.getElementsByClassName("ace_gutter-cell");
          for(var i=0;i<elements1.length;i++){
            elements1[i].className = "ace_gutter-cell";
          }
    
          this.running = false;
          try{
            this.processing = new Processing(this.$refs.canvas, this.code);
            console.log(this.processing)
            this.result = 1;
          }
          catch(err){
             
            this.result = 0;
            this.error = err;
          } 
        }
        else{
          this.result = -1;
          this.resultText = null;
          var postInfo = {};
            postInfo.code = encodeURIComponent(this.code);
            postInfo.language = 8;
            postInfo.stdin = this.stdin;
            postInfo.fileext = "java";

            this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
              console.log(response.data);
              this.running = false;
              this.resultText = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
            });
        }
      },
      stop() {
        this.code = "";
        this.result = -1;
        this.error = null;
        this.processing.exit();
      },
    },
  };
  </script>
  
  <style lang="scss">
  
  .content{
    position: fixed;
    top:56px;
    left:0px;
    width:100%;
    height:calc(100% - 56px);
    display: flex;
  
    .coder{
      width:60%;
      height:100%;
      overflow: auto;
      position: relative;
  
      .editor{
        width:100%;
        height:calc(100% - 46px) !important;
        margin-top:46px;
        background:#f5fdfb;
        
  
        .ace_print-margin{
          display: none;
        }

        &.editor-font-1{
          font-size: 12px !important;
        }

        &.editor-font-2{
          font-size: 14px !important;
        }

        &.editor-font-3{
          font-size: 16px !important;
        }
      }

      .font-setting{
        position: absolute;
        right:10px;
        top:10px;
        display: flex;
        border: 1px solid #eee;

        .item{
          width:35px;
          text-align: center;
          font-size:14px;
          background:white;
          cursor: pointer;

          &.active{
            background:#04b2c5;
            color:white;
          }
        }
      }
    }
    .panel{
      width:40%;
      border-left:1px solid #eee;
      .result{
        width:100%;
        height:50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border-bottom:1px solid #eee;
  
        .title{
          position: absolute;
          top:0px;
          left:0px;
          width:100%;
          padding:10px;
          font-weight:bold;
          font-size:14px;
        }
        canvas{
          max-width: initial;
          max-height:initial
        }
      }
  
      .notes{
        width:100%;
        height:50%;
        //background:black;
        overflow: auto;
  
        .tabs{
          display: flex;
          
          font-size:14px;
          justify-content: space-around;
          .tab{
            width:50%;
            text-align: center;
            padding:10px 0px;
            cursor: pointer;
            border-bottom: 1px solid #eee;;
            
            &.active{
              background: #04b2c5;
              
              color:white;
            }
          }
        }
      }
    }
  }
  
  .buttons{
    position: fixed;
    bottom:10px;
    right:41%;
    z-index: 10;
  }
  
  .ace_gutter-cell.error-line{
    background:orangered;
    color:white;
  }
  
  
  .ace_gutter-cell .ace_fold-widget{
    display: none !important
  }
  
  
  // .ace_gutter-cell{
  //   height:18px !important;
  //   line-height:18px !important;
  // }
  
  // .ace_line{
  //   height:18px !important;
  //   line-height:18px !important;
  //   font-size:15px !important;
  // }
  // .ace_gutter-active-line{
  //   height:18px !important;
  //   line-height:18px !important;
  // }
  // .ace_cursor{
  //   height:18px !important;
  //   line-height:18px !important;
  // }
  
  .pjsconsole{
    width:60% !important;
    height:150px !important;
    .console{
      overflow-y: auto !important;
      height:150px !important;
      padding-bottom:20px;
    }
  }
  
  .project-row{
    display:flex;
    justify-content: space-between;
    padding:5px 10px;
    font-size:15px;
    cursor: pointer;
  
    &:hover{
      background:#eee;
    }
  }
  
  .class-row{
    padding:5px 10px;
    font-size:15px;
    cursor: pointer;
  
    &:hover{
      background:#eee;
    }
  }
  
  .topic-row{
    cursor: pointer;
    font-size:13px;
    padding:3px 20px;
    padding-right:8px;
    display: flex;
    color:#666;
    justify-content: space-between;
  
    &:hover{
      background:#eee;
    }
  }
  
  .error-layer{
    position: fixed;
    bottom:0px;
    height:180px;
    left:0px;
    width:60%;
    background:#eee;
    border-top:1px solid #ccc;
  }
  .ace_identifier{
    color:rgb(189, 60, 1);
  
  }
  
  .ace_numeric{
    color:#038795 !important;
  }
  
  .ace_keyword{
    color:rgb(43, 90, 1) !important;
  
  }
  </style>